// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.5770b8c89c1ae5065a57ba11abfe590ae921f4ef.js";
};